export default __webpack_public_path__ + "static/media/areum-jo.c7558542.jpg";